module.exports = __webpack_public_path__ + "img/ctf.75e15f88.jpg";